import React from 'react'
import TextField from '@mui/material/TextField'
import { useInput } from 'ra-core'
import { NumericFormat } from 'react-number-format'

export const NumberInput = ({
  className,
  defaultValue = null,
  label,
  onChange,
  resource,
  source,
  noDecimal = false,
  validate,
  helperText,
  ...rest
}) => {
  const {
    field,
    fieldState: { error },
  } = useInput({
    defaultValue,
    resource,
    source,
    validate,
    ...rest,
  })

  const handleChange = (event) => {
    if (onChange) {
      onChange(event)
    }
    field.onChange(event.target.value)
  }

  return (
    <NumericFormat
      value={field.value}
      customInput={TextField}
      onValueChange={(e) => handleChange({ target: { value: e.floatValue } })}
      size='small'
      helperText={error?.message || helperText}
      error={error?.message ? true : false}
      decimalScale={noDecimal ? 0 : 2}
      {...rest}
    />
  )
}
